export default "__VITE_ASSET__c19557a7__"